import React, { useEffect, useState, useRef,useContext } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import CreateACopyIcon from '@assets/icons/createACopyIcon';
import EditIcon from '@assets/icons/editIcon';
import ShareIcon from '@assets/icons/shareIcon';
import VersionIcon from '@assets/icons/versionHistoryIcon';
import { Context } from './../../../Context';
import ContentStructure from '../../ContentStructure';
import { PermissionEnum } from '@state/designs/types';

const EditorOptions:React.FC<IProps> = (props) => {
  const context = useContext(Context);
  const useOutsideAlerter = (ref:any) => {
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          props.setOpen(false);
        }
      }
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  const optionsRef = useRef(null);
  useOutsideAlerter(optionsRef);

  const handleCreateACopy = () => {
    props.onActions("CREATEACOPY");
    props.setOpen(false);
  }

  const handleEditName = () =>{
    props.onActions("EDITNAME");
    props.setOpen(false);
  }

  const returnLeftValue = () => {
    var value = props.coordinates.x;
    if (value + 335 > window.innerWidth) {
      value = value - 335;
    }
    return value;
  }

  const returnTopValue = () => {
    var value = props.coordinates.y - 300;
    if (value < 10) {
      value = 10;
    }
    return value;
  }

  const handleShare=()=>{
    props.setOpen(false);
    context.onSharing(true);    
  }

  const handleVersionHistory = () => {  
    props.setOpen(false);
    const picker = (context.editorStatus.currentPicker==="VersionHistory")?undefined:"VersionHistory";
    context.onShowPicker(picker, {right:true});
    if (picker=== undefined)
      context.onSelectEditMode(true)
  }

  return (
    <S.Root 
      ref={optionsRef}
      leftValue={`${returnLeftValue()}px`}
      topValue={`${returnTopValue()}px`}
    >
      {
        props.open &&
        <S.PopupContainer>
          <S.Title>
            {props.labels.name}
          </S.Title>
          <S.DescriptionContainer>
            <S.Description>
              {`Last Edited: ${props.labels.lastEditedDate} by ${props.labels.editedBy}`}
            </S.Description>
          </S.DescriptionContainer>
          <S.OptionsContainer>
            <S.OptionContainer
              onClick={handleCreateACopy}
            >
              <S.OptionIconContainer>
                <CreateACopyIcon />
              </S.OptionIconContainer>
              <S.OptionText>
                {`Create a Copy`}
              </S.OptionText>
            </S.OptionContainer>
            { context.userPermission === PermissionEnum.EDIT &&
              <S.OptionContainer
                onClick={handleEditName}
              >
                <S.OptionIconContainer>
                  <EditIcon />
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Edit Name`}
                </S.OptionText>              
              </S.OptionContainer>
            }
            {
              (!context.editorStatus.showSelectDescribe && context.userPermission === PermissionEnum.EDIT) &&
              <>
            <S.OptionContainer
              onClick={handleShare}
            >
              <S.OptionIconContainer>
                <ShareIcon />
              </S.OptionIconContainer>
              <S.OptionText>
                {`Share`}
              </S.OptionText>
            </S.OptionContainer>
            <S.OptionContainer
              onClick={handleVersionHistory}
            >
              <S.OptionIconContainer>
                <VersionIcon />
              </S.OptionIconContainer>
              <S.OptionText>
                {`Version History`}
              </S.OptionText>
            </S.OptionContainer>
            </>
              }
            </S.OptionsContainer>
              
        </S.PopupContainer>
      }
    </S.Root>
  );
}

export default EditorOptions;
